import { render, staticRenderFns } from "./system_single_page_list.vue?vue&type=template&id=45268414"
import script from "./system_single_page_list.vue?vue&type=script&lang=js"
export * from "./system_single_page_list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports